module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/arrow-9500d8a67022feba3164ddaeb6c64697.svg";